if (!customElements.get('recipient-form')) {
  customElements.define(
    'recipient-form',
    class RecipientForm extends HTMLElement {
      constructor() {
        super();
        const id = this.dataset.sectionId;
        this.checkboxInput = this.querySelector(`#Recipient-checkbox-${id}`);
        this.checkboxInput.disabled = false;
        this.hiddenControlField = this.querySelector(`#Recipient-control-${id}`);
        this.hiddenControlField.disabled = true;
        this.emailInput = this.querySelector(`#Recipient-email-${id}`);
        this.nameInput = this.querySelector(`#Recipient-name-${id}`);
        this.messageInput = this.querySelector(`#Recipient-message-${id}`);
        this.sendonInput = this.querySelector(`#Recipient-send-on-${id}`);
        this.offsetProperty = this.querySelector(`#Recipient-timezone-offset-${id}`);
        if (this.offsetProperty) this.offsetProperty.value = new Date().getTimezoneOffset().toString();

        this.addEventListener('change', this.onChange.bind(this));
        this.onChange();
      }

      onChange() {
        this.classList.toggle('is-open', this.checkboxInput.checked);
        if (this.checkboxInput.checked) {
          this.enableInputFields();
        } else {
          this.clearInputFields();
          this.disableInputFields();
        }
      }

      inputFields() {
        return [this.emailInput, this.nameInput, this.messageInput, this.sendonInput];
      }

      disableableFields() {
        return [...this.inputFields(), this.offsetProperty];
      }

      clearInputFields() {
        this.inputFields().forEach((field) => { if (field) field.value = ''; });
      }

      enableInputFields() {
        this.disableableFields().forEach((field) => { if (field) field.disabled = false; });
      }

      disableInputFields() {
        this.disableableFields().forEach((field) => { if (field) field.disabled = true; });
      }
    }
  );
}
